import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import RemoveIcon from '@mui/icons-material/Remove';
import {Divider, IconButton, Paper, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const Container = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));

const MapTool = styled(IconButton)(({theme}) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  color: 'inherit',
  display: 'block',
  position: 'relative',
}));

const MapTools = ({onZoomClick, onHomeClick, showHome}) => (
  <Container>
    {showHome && (
      <React.Fragment>
        <MapTool onClick={() => onHomeClick()}>
          <HomeIcon />
        </MapTool>
        <Divider />
      </React.Fragment>
    )}
    <MapTool onClick={() => onZoomClick(1)}>
      <AddIcon />
    </MapTool>
    <MapTool onClick={() => onZoomClick(-1)}>
      <RemoveIcon />
    </MapTool>
  </Container>
);

MapTools.propTypes = {
  onZoomClick: PropTypes.func,
  onHomeClick: PropTypes.func,
  showHome: PropTypes.bool,
};

MapTools.defaultProps = {
  showHome: false,
};

export default MapTools;
